export default __webpack_public_path__ + "static/media/hk_flashpay_fees_backgound.629b4e10.png";